module.exports = __webpack_public_path__ + "img/logo.7598343a.png";